import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.291 11.272l5-4.979a.999.999 0 0 1 1.415.002c.39.39.384 1.03 0 1.413l-4.295 4.276 4.3 4.306c.385.385.391 1.025.001 1.416a.998.998 0 0 1-1.415 0L8.29 12.692a1.001 1.001 0 0 1-.29-.676.999.999 0 0 1 .29-.745z"
});

var SvgArrowLeftSmall = function SvgArrowLeftSmall(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgArrowLeftSmall;